import { useState } from 'react'
import { Popover, Stack, Typography } from '@mui/material'
import { formatDate } from '../../helpers'

export function useDevolucionesPopover() {
  const [devolucionesPopover, setDevolucionesPopover] = useState({
    anchorEl: null,
    desglose: [],
  })

  const open = Boolean(devolucionesPopover.anchorEl)

  const handleOpen = (event, desglose) => {
    setDevolucionesPopover({ anchorEl: event.currentTarget, desglose: desglose || [] })
  }

  const handleClose = () => {
    setDevolucionesPopover({ anchorEl: null, desglose: [] })
  }

  const toggle = (event, desglose) => {
    if (open) {
      handleClose()
    } else {
      handleOpen(event, desglose)
    }
  }

  return { ...devolucionesPopover, open, handleOpen, handleClose, toggle }
}

export const DevolucionesPopover = ({ open, anchorEl, onClose, items }) => (
  <Popover
    open={open}
    anchorEl={anchorEl}
    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
    onClose={onClose}
    TransitionProps={{ timeout: { exit: 0 } }}
    disableRestoreFocus
  >
    <Stack spacing={0.5} sx={{ p: 1.5, backgroundColor: 'rgba(250,250,250,0.9)', maxHeight: '100px', overflowY: 'auto' }}>
      {items.map((item) => (
        <Stack key={item.date} spacing={4} direction="row" justifyContent="space-between">
          <Typography sx={{ fontSize: '0.8rem', color: 'text.secondary' }}>
            {formatDate(new Date(item.date), 'es-ES', { year: 'numeric', month: '2-digit', day: '2-digit' })}
          </Typography>
          <Typography sx={{ fontSize: '0.8rem', color: 'text.primary' }}>{item.num}</Typography>
        </Stack>
      ))}
    </Stack>
  </Popover>
)
